import axios from 'axios';

type Props = {
    eventUrl: string;
    rotaryCd: string;
}

/**
 * キャンセル待ちを登録している会員情報を取得するAPI
 */
export async function getCancelwaitUsers({eventUrl, rotaryCd}: Props){
    const response = await axios.get(process.env.REACT_APP_PATH + `/users/member/event/cancelwait`, {
        params: {
            rotaryCd: rotaryCd,
            url: eventUrl
        }
    })

    return JSON.parse(JSON.stringify(response.data))
}